'use client';

import { createContext, useContext } from 'react';
import Tracker from '@/app/utils/tracker';

const tracker = new Tracker();

export const TrackingContext = createContext<Tracker>(tracker);

export const useTracking = () => useContext(TrackingContext);

export default function TrackingProvider({ children }: { children: React.ReactNode }) {
  return <TrackingContext.Provider value={tracker}>{children}</TrackingContext.Provider>;
}
